module.exports = __webpack_public_path__ + "img/join.c67ee517.jpg";